"use strict"

export default function routes($stateProvider) {
  "ngInject"

  $stateProvider.state("mainmap.home.availability-status", {
    url: "/availability-status",
    component: "availabilitystatus",
  })
}
